import { formatNumberWithPrecision } from '@/utils/formatNumberWithPrecision';
import roundHalfUp from '@/utils/roundHalfUp';

export default function formatNumberInBraces(value: string) {
  const bracePattern = /\{([^{}]*)}/g;

  return value.replaceAll(bracePattern, (_, content) => {
    const result = content.trim();
    if (!result) return '';
    if (Number.isNaN(Number(result))) {
      return result;
    }
    try {
      const number = Number(result);
      const decimalsToRound = 2;
      return formatNumberWithPrecision(
        roundHalfUp(number, decimalsToRound).toFixed(decimalsToRound)
      );
    } catch {
      return result;
    }
  });
}
